module.exports = __webpack_public_path__ + "img/humia.2ae9c871.png";